// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2Rl-n","options":"styles_options__3jDrl","title":"styles_title__2mZAp","content":"styles_content__2M7yx","helpBlock":"styles_helpBlock__2u_wB"};